import React from 'react';

type ButtonVariant = 'primary' | 'accent' | 'secondary' | 'ghost' | 'outline';
type ButtonSize = 'sm' | 'md' | 'lg';

interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  fullWidth?: boolean;
}

export const Button: React.FC<ButtonProps> = ({
  children,
  className = '',
  variant = 'primary',
  size = 'md',
  fullWidth = false,
  ...props
}) => {
  const baseStyles = 'inline-flex items-center justify-center font-semibold rounded-full transition-all focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed';
  
  const variants = {
    primary: 'bg-[var(--v-teal-700)] text-white hover:bg-[var(--v-teal-800)] focus:ring-[var(--v-teal-700)] shadow-sm',
    accent: 'bg-[var(--v-teal-400)] text-[var(--v-teal-900)] hover:bg-[var(--v-teal-500)] focus:ring-[var(--v-teal-400)] shadow-sm',
    secondary: 'bg-[var(--v-surface-1)] text-[var(--v-text-primary)] border border-[var(--v-border-strong)] hover:bg-[var(--v-surface-2)] focus:ring-[var(--v-text-primary)]',
    ghost: 'bg-transparent text-[var(--v-text-secondary)] hover:bg-[var(--v-surface-2)] hover:text-[var(--v-text-primary)] focus:ring-[var(--v-text-secondary)]',
    outline: 'bg-transparent text-[var(--v-teal-700)] border border-[var(--v-teal-700)] hover:bg-[var(--v-teal-50)] focus:ring-[var(--v-teal-700)]'
  };
  
  const sizes = {
    sm: 'text-sm px-3 py-1.5',
    md: 'text-base px-4 py-2',
    lg: 'text-lg px-6 py-3'
  };

  const classes = [
    baseStyles,
    variants[variant],
    sizes[size],
    fullWidth ? 'w-full' : '',
    className
  ].join(' ');

  return (
    <button className={classes} {...props}>
      {children}
    </button>
  );
};
